import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Select } from "antd";
import { settingOtodisApiService } from "../../services/otodis/SettingOtodisApiService";

class SelectDeliveryVehicle extends Component<any, any> {
  private readonly initState!: any;
  private token = new Cookies().get("_t");

  constructor(props: any) {
    super(props);

    this.initState = {
      dataAsset: [],
      selectSupplierValue: null,
    };
    this.state = { ...this.initState };
  }

  fetchAssetData = async (dealerCode: any) => {
    const mockDataTemp: any = [];
    // FETCH API
    if (dealerCode.length > 0) {
      for (const dlrTemp of dealerCode) {
        const dlr = dlrTemp.split(" | ")[0];
        settingOtodisApiService.setToken(this.token);
        await settingOtodisApiService
          .getDeliveryVehicle({ dealerCode: dlr, active: true })
          .then((dataFetch) => {
            for (const item of dataFetch.data.data) {
              const data = {
                value: item.vehicle_license_plate,
                name: item.vehicle_license_plate,
              };
              mockDataTemp.push(data);
            }
          })
          .catch((error) => {
            console.error(`Error fetching data for dealer code: ${dlr}`, error);
          });

        this.setState({
          dataAsset: mockDataTemp,
          selectSupplierValue: null,
        });
      }
    }
  };

  onChange = (value: any, option: any) => {
    this.setState({
      selectSupplierValue: value,
    });

    this.props.onAssetChangeProps(option);
  };

  onValueChange = (value: any) => {
    this.setState({
      selectSupplierValue: value,
    });
  };

  async componentDidMount() {
    this.fetchAssetData(this.props.dealerCode);
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if (this.props.dealerCode !== prevProps.dealerCode) {
      this.fetchAssetData(this.props.dealerCode);
    }

    if (this.props.value !== prevProps.value) {
      this.onValueChange(this.props.value);
    }
  }

  render() {
    return (
      <Select
        showSearch
        placeholder="Pilih Asset"
        optionFilterProp="children"
        onChange={this.onChange}
        filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        value={this.state.selectSupplierValue}
      >
        {this.state.dataAsset.map((item: any, i: number) => (
          <Select.Option key={item?.value} value={item?.value}>
            {item?.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default SelectDeliveryVehicle;
